import { useState } from "react";
import { Outlet, useLocation, useMatches } from "react-router-dom";
import { TopBar } from "./TopBar";
import { StickySidebar } from "./Sidebar";
import { MobileDrawer } from "./MobileDrawer";
import { roleConfigs, roleFromPath, type RoleConfig } from "./roles";

type RouteHandle = { title?: string | ((params: Record<string, string | undefined>) => string) };

export function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const matches = useMatches();
  const role: RoleConfig = roleConfigs[roleFromPath(location.pathname)];

  // Берём title последнего матча, если он есть
  const last = [...matches].reverse().find((m) => (m.handle as RouteHandle)?.title);
  const h = last?.handle as RouteHandle | undefined;
  const t = h?.title;
  const params = (last?.params ?? {}) as Record<string, string | undefined>;
  const pageTitle = typeof t === "function" ? t(params) : t;

  return (
    <div className="flex min-h-screen flex-col bg-[var(--color-surface-2)]">
      <TopBar role={role} onMenu={() => setDrawerOpen(true)} current={pageTitle} />
      <div className="flex flex-1">
        <StickySidebar role={role} />
        <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} role={role} />
        <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 md:px-8 md:py-8">
          <div className="mx-auto max-w-[1200px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
